import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { catchError, of, tap } from 'rxjs';

import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc, TcExpanded, TcPerfilUsuarioEnum, WBotanicaExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../solicitudes/types/enum';
import { BuscadorProductoService } from './buscador-producto.service';
import { FilterSearchingProductoViewModel, ProductoItemResultsViewModel, ProductoItemViewModel } from './buscador-producto.types';
import { LaboratorioService } from '../../solicitudes/laboratorio/laboratorio.service';

@Component({
    selector: 'app-buscador-producto-list',
    templateUrl: './buscador-producto-list.component.html',
})
export class BuscadorProductoListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    @ViewChild(EspecieEppoPopupComponent)
    private especieEppoPopupComponent: EspecieEppoPopupComponent;

    listSiNoTodos: SelectItem[];
    resultProductos: ProductoItemResultsViewModel;
    listPais: Tc[];
    listTipoSolicitud: TcExpanded[];
    listProvincias: Tc[];
    listPuntoInspeccion: Tc[];
    listGrupo: Tc[];
    listForma: Tc[];
    listEstado: Tc[];
    listResultadoEnvioMuestrasLaboratorio: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    isCollapsed = false;
    paisEspania = 0;

    IdForma = 0;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private buscadorproductoService: BuscadorProductoService,
        private laboratorioService: LaboratorioService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultProductos = new ProductoItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            { field: 'TipoSolicitud', header: 'Tipo' },
            { field: 'EstadoSolicitud', header: 'Estado' },
            { field: 'PuntoInspeccion', header: 'Punto Inspección' },
            { field: 'CodigoTaric', header: 'Código Taric' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'NombreCientifico', header: 'Nombre Cientí­fico' },
            { field: 'Grupo', header: 'Grupo ' },
            { field: 'Forma', header: 'Forma' },
            { field: 'RazonSocial', header: 'Solicitante' },
            { field: 'PaisOrigen', header: 'País de Origen' },
            { field: 'PesoNeto', header: 'Peso Neto (kg)' },
            { field: 'Nrc', header: 'Nº Autorización' },
            { field: 'EsPredua', header: 'Pre DUA' },
            { field: 'IdEstadoSolicitud', header: 'IdEstado', display: 'none' },
            { field: 'Matriculas', header: 'Matrí­culas' },
            //{ field: 'EsPrevia', header: 'Previa' },
            {
                field: 'IdResultadoEnvioMuestrasLaboratorio',
                header: 'IdResultadoEnvioMuestrasLaboratorio',
                display: 'none',
            },
            { field: 'CodigoTraces', header: 'Código Traces­' },
            { field: 'Exportador', header: 'Exportador' },
            { field: 'FechaLlegada', header: 'Fecha/Hora Llegada' },
            { field: 'NumeroOmi', header: 'Buque/Matrícula/AWB' },
        ];

        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getTipoSolicitudActivos().subscribe(res => {
            this.listTipoSolicitud = res;
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        let params = new HttpParams();
        if (this.buscadorproductoService.currentFilterProducto?.IdProvincia != null) {
            params = params.append('id', this.buscadorproductoService.currentFilterProducto?.IdProvincia!.toString());
            params = params.append('esimportacion', 'true');
            this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
                this.listPuntoInspeccion = res;
            });
        }

        this.globalService.getEstadoSolicitud().subscribe(res => {
            this.listEstado = res;
        });
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });
        this.globalService.getFormasByGrupo(this.buscadorproductoService.currentFilterProducto?.IdGrupo || 0).subscribe(res => {
            this.listForma = res;
        });

        this.laboratorioService.getResultadosMuestraLaboratorio().subscribe(res => {
            this.listResultadoEnvioMuestrasLaboratorio = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            IdEstadoSolicitud: null,
            IdPais: null,
            IdTipoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            IdGrupo: null,
            IdForma: null,
            IdEstadoInspeccion: null,
            Codigo: '',
            CodigoTaric: '',
            CodigoEppo: '',
            NombreComun: '',
            IdResultadoEnvioMuestrasLaboratorio: null,
            EsPredua: EnumSiNoTodos.TODOS,
            //EsPrevia: false,
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            Matriculas: '',
            CodigoTraces: '',
            Exportador: '',
        });

        const config = this.getConfig();
        this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        if (
            this.buscadorproductoService.currentFilterProducto.FechaDesde == null ||
            this.buscadorproductoService.currentFilterProducto.FechaHasta == null ||
            this.buscadorproductoService.currentFilterProducto.IdEstadoSolicitud != null ||
            this.buscadorproductoService.currentFilterProducto.IdPais != null ||
            this.buscadorproductoService.currentFilterProducto.IdProvincia != null ||
            this.buscadorproductoService.currentFilterProducto.IdPuntoInspeccion != null ||
            this.buscadorproductoService.currentFilterProducto.IdTipoSolicitud != null ||
            this.buscadorproductoService.currentFilterProducto.CodigoEppo != '' ||
            this.buscadorproductoService.currentFilterProducto.CodigoTaric != '' ||
            this.buscadorproductoService.currentFilterProducto.EsPredua != false ||
            //|| this.buscadorproductoService.currentFilterProducto.EsPrevia != false
            this.buscadorproductoService.currentFilterProducto.IdGrupo != null ||
            this.buscadorproductoService.currentFilterProducto.IdForma != null ||
            this.buscadorproductoService.currentFilterProducto.NombreComun != '' ||
            this.buscadorproductoService.currentFilterProducto.Codigo != '' ||
            this.buscadorproductoService.currentFilterProducto.IdResultadoEnvioMuestrasLaboratorio != null ||
            this.buscadorproductoService.currentFilterProducto.TieneEnvioDeMuestras != EnumSiNoTodos.TODOS ||
            this.buscadorproductoService.currentFilterProducto.FechaDesde!.toString() != this.firstDayMonth.toString() ||
            this.buscadorproductoService.currentFilterProducto.FechaHasta!.toString() != this.lastDayMonth.toString() ||
            this.buscadorproductoService.currentFilterProducto.Matriculas != '' ||
            this.buscadorproductoService.currentFilterProducto.CodigoTraces != '' ||
            this.buscadorproductoService.currentFilterProducto.Exportador != ''
        ) {
            this.form.patchValue({
                IdEstadoSolicitud: this.buscadorproductoService.currentFilterProducto.IdEstadoSolicitud,
                IdPais: this.buscadorproductoService.currentFilterProducto.IdPais,
                IdProvincia: this.buscadorproductoService.currentFilterProducto.IdProvincia,
                IdPuntoInspeccion: this.buscadorproductoService.currentFilterProducto.IdPuntoInspeccion,
                IdTipoSolicitud: this.buscadorproductoService.currentFilterProducto.IdTipoSolicitud,
                CodigoEppo: this.buscadorproductoService.currentFilterProducto.CodigoEppo,
                CodigoTaric: this.buscadorproductoService.currentFilterProducto.CodigoTaric,
                Codigo: this.buscadorproductoService.currentFilterProducto.Codigo,
                EsPredua: this.buscadorproductoService.currentFilterProducto.EsPredua,
                //EsPrevia: this.buscadorproductoService.currentFilterProducto.EsPrevia,
                IdGrupo: this.buscadorproductoService.currentFilterProducto.IdGrupo,
                IdForma: this.buscadorproductoService.currentFilterProducto.IdForma,
                NombreComun: this.buscadorproductoService.currentFilterProducto.NombreComun,
                IdResultadoEnvioMuestrasLaboratorio: this.buscadorproductoService.currentFilterProducto.IdResultadoEnvioMuestrasLaboratorio,
                TieneEnvioDeMuestras: this.buscadorproductoService.currentFilterProducto.TieneEnvioDeMuestras,
                FechaDesde: this.buscadorproductoService.currentFilterProducto.FechaDesde,
                FechaHasta: this.buscadorproductoService.currentFilterProducto.FechaHasta,
                Matriculas: this.buscadorproductoService.currentFilterProducto.Matriculas,
                CodigoTraces: this.buscadorproductoService.currentFilterProducto.CodigoTraces,
                Exportador: this.buscadorproductoService.currentFilterProducto.Exportador,
            });

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel(): FilterSearchingProductoViewModel {
        const model: FilterSearchingProductoViewModel = new FilterSearchingProductoViewModel();

        model.IdPais = this.form.value.IdPais;
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.IdTipoSolicitud = this.form.value.IdTipoSolicitud;
        model.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        model.CodigoEppo = this.form.value.CodigoEppo;
        model.CodigoTaric = this.form.value.CodigoTaric;
        model.EsPredua = this.form.value.EsPredua;
        //model.EsPrevia = this.form.value.EsPrevia;
        model.NombreComun = this.form.value.NombreComun;
        model.Codigo = this.form.value.Codigo;
        model.IdGrupo = this.form.value.IdGrupo;
        model.IdForma = this.form.value.IdForma;
        model.IdResultadoEnvioMuestrasLaboratorio = this.form.value.IdResultadoEnvioMuestrasLaboratorio;
        model.TieneEnvioDeMuestras = this.form.value.TieneEnvioDeMuestras;
        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta;

        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = this.isInspector;
        model.EsCoordinador = this.isCoordinador;
        model.EsSolicitante = this.isSolicitante;
        model.EsGrabador = this.isGrabador;
        model.EsConsultas = this.isConsultas;
        model.EsConsultasySolicitante = this.isConsultas && this.isSolicitante;

        model.Matriculas = this.form.value.Matriculas;
        model.CodigoTraces = this.form.value.CodigoTraces;
        model.Exportador = this.form.value.Exportador;

        return model;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        const model: FilterSearchingProductoViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaHasta != null) {
            model.FechaHasta.setHours(23);
            model.FechaHasta.setMinutes(59);
            model.FechaHasta.setSeconds(59);
        }

        this.buscadorproductoService
            .postProductoPagedByFilter(model)
            .pipe(
                tap(result => {
                    this.resultProductos = result;
                    this.loading = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form?.disable();
                    return of(null);
                }),
            )
            .subscribe();

        this.buscadorproductoService.currentFilterProducto = model;
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            IdEstadoSolicitud: null,
            IdPais: null,
            IdTipoSolicitud: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            IdEstadoInspeccion: null,
            IdGrupo: null,
            IdForma: null,
            Codigo: '',
            CodigoEppo: '',
            CodigoTaric: '',
            NombreComun: '',
            EsPredua: EnumSiNoTodos.TODOS,
            //EsPrevia: false,
            IdResultadoEnvioMuestrasLaboratorio: null,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            Matriculas: '',
            CodigoTraces: '',
            Exportador: '',
        });

        this.isCollapsed = false;
        this.searchingButton = false;

        this.resultProductos = new ProductoItemResultsViewModel();
    }

    onAcceptDialogEspecieEppo(especieEppo: WBotanicaExtendedViewModel): void {
        //this.infoPaisPartidaPredua = partidaPredua.PaisOrigen;
        this.form.patchValue({
            CodigoEppo: especieEppo.CodigoEppo,
            //NombreBotanico: especieEppo.NombreCientifico,
            NombreComun: especieEppo.NombreComun,
        });
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.form.controls['IdGrupo'].value, this.IdForma, null, false);
    }

    onSelectPais(): void {
        // NO-OP
    }

    onSelectProvincia(): void {
        const idProvincia = this.form.value.IdProvincia;

        let params = new HttpParams();
        params = params.append('id', idProvincia?.toString() || null);
        params = params.append('esimportacion', 'true');

        this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.form.patchValue({
            IdPuntoInspeccion: null,
        });
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo || null;
        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });

        this.form.patchValue({
            IdForma: null,
        });
    }

    onSelectForma(): void {
        this.IdForma = this.form.value.IdForma;

        if (this.IdForma == null) {
            this.habilitarBusquedaEppo = false;
        } else {
            this.habilitarBusquedaEppo = true;
        }

        this.form.patchValue({
            CodigoEppo: '',
            //NombreBotanico: '',
            NombreComun: '',
        });
    }

    checkEdit(rowData: ProductoItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_PRODUCTOS, rowData.IdEstadoSolicitud).Editable;
    }

    checkDelete(rowData: ProductoItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_SOLICITUD, rowData.IdEstadoSolicitud).Visible;
    }

    onEdit(item: ProductoItemViewModel): void {
        this.router.navigate(['/importacion/solicitud/productos', item.IdSolicitud, 'producto', item.Id]);
        //this.router.navigate(["/mantenimiento/especies/grupos/edit", idGrupo, "formas", "edit", this.subforma.IdForma])
    }

    onDelete(item: ProductoItemViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de eliminar el producto?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.buscadorproductoService.deleteProducto(item.Id).subscribe(() => {
                    this.addSuccessMessage('Producto eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;
        this.buscadorproductoService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultProductos?.ResultList ? this.resultProductos?.ResultList?.length > 0 : false;
    }
}
